<div class="u-cubeportfolio mb-5 mt-4">
    <!-- Filter -->
    <div class="card border-1 py-2 mb-4 bg-dark cubeBox">
        <ul id="filterControls" class="list-inline cbp-l-filters-alignRight text-center"
            style="height: 30px; margin-bottom: 0 !important;">
            <li [ngClass]="getRenderClass()"
                class="list-inline-item cbp-filter-item u-cubeportfolio__item" data-filter="*">
                All
            </li>
            <span [ngClass]="getRenderClass()">|</span>
            <li class="list-inline-item cbp-filter-item u-cubeportfolio__item" data-filter=".hotel">
                <span *ngIf="showLegend && isNotMobile()" appCuteIcon class="pr-1 pb-2" type="hotel" folder="icons"
                      sizeInPixels="18"></span>
                <span class="activeUnderline">Hotels</span>
            </li>
            |
            <li class="list-inline-item cbp-filter-item u-cubeportfolio__item" data-filter=".lodge">
                <span *ngIf="showLegend && isNotMobile()" appCuteIcon class="pr-1" type="crown" folder="icons" sizeInPixels="18"></span>
                <span class="activeUnderline">Safari Lodges</span>
            </li>
            |
            <li class="list-inline-item cbp-filter-item u-cubeportfolio__item" data-filter=".camp">
                <span *ngIf="showLegend && isNotMobile()" appCuteIcon class="pr-1" type="tent" folder="icons" sizeInPixels="18"></span>
                <span class="activeUnderline">Wild Camps</span>
            </li>
        </ul>
    </div>
    <!-- End Filter -->

    <!-- Content -->
    <div class="cbp" id="hotelCubes"
         data-layout="grid"
         data-controls="#filterControls"
         data-animation="quicksand"
         data-x-gap="32"
         data-media-queries='[
        {"width": 1500, "cols": 3},
        {"width": 1100, "cols": 3},
        {"width": 500, "cols": 3},
        {"width": 480, "cols": 2},
        {"width": 300, "cols": 1}
      ]'>
        <!-- Item -->
        <div class="cbp-item rounded hotel" id="springlandsHotelCube">
            <a class="cbp-caption">
                <div class="cbp-caption-defaultWrap">
                    <img width="320px" style="height:190px" appLazyload="hotels/springlands/springlands-flowers-thumb.jpg"
                         alt="Beautiful flowers at the Springlands Hotel in Moshi, Tanzania">
                </div>
                <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-pink' : 'bg-primary'"
                     routerLink="/hotels/springlands-hotel">
                    <div class="cbp-l-caption-alignCenter">
                        <div class="cbp-l-caption-body">
                            <h4 class="h6 text-white mb-0">Springlands Hotel</h4>
                            <p class="small text-white-70 mb-0">
                                Click to learn more!
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <!-- End Item -->

        <!-- Item -->
        <div class="cbp-item rounded hotel" id="highviewHotelCube">
            <a class="cbp-caption">
                <div class="cbp-caption-defaultWrap">
                    <img width="320px" style="height:190px" appLazyload="hotels/highview/highview-banner-thumb.jpg" alt="View of Rooms at Highview Hotel in Tanzania">
                </div>
                <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-pink' : 'bg-primary'"
                     routerLink="/hotels/highview-hotel">
                    <div class="cbp-l-caption-alignCenter">
                        <div class="cbp-l-caption-body">
                            <h4 class="h6 text-white mb-0">Highview Hotel</h4>
                            <p class="small text-white-70 mb-0">
                                Click to learn more!
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <!-- End Item -->

        <!-- Item -->
        <div class="cbp-item rounded camp" id="ikomaWildCampCube">
            <a class="cbp-caption">
                <div class="cbp-caption-defaultWrap">
                    <img width="320px" style="height:190px" appLazyload="hotels/ikoma/ikoma-banner-thumb.jpg" alt="Ikoma Wild Camp">
                </div>
                <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-secondary' : 'bg-primary'"
                     routerLink="/hotels/ikoma-wild-camp">
                    <div class="cbp-l-caption-alignCenter">
                        <div class="cbp-l-caption-body">
                            <h4 class="h6 text-white mb-0">Ikoma Wild Camp</h4>
                            <p class="small text-white-70 mb-0">
                                Click to learn more!
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <!-- End Item -->
        <!-- Item -->
        <div class="cbp-item rounded camp" id="ngorongoroWildCampCube">
            <a class="cbp-caption">
                <div class="cbp-caption-defaultWrap">
                    <img width="320px" style="height:190px" appLazyload="hotels/ngorongoro-camp/ngor-camp-room-thumb.jpg" alt="View of Bedroom in Ngorongoro Wild Camp">
                </div>
                <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-secondary' : 'bg-primary'"
                     routerLink="/hotels/ngorongoro-wild-camp">
                    <div class="cbp-l-caption-alignCenter">
                        <div class="cbp-l-caption-body">
                            <h4 class="h6 text-white mb-0">Ngorongoro Wild Camp</h4>
                            <p class="small text-white-70 mb-0">
                                Click to learn more!
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>

        <div class="cbp-item rounded lodge" id="serengetiSafariLodgeCube">
            <a class="cbp-caption">
                <div class="cbp-caption-defaultWrap">
                    <img width="320px" style="height:190px" appLazyload="hotels/serengeti-lodge/safari-lodge-bed-thumb.jpg"
                         alt="View of a bedroom at the Serengeti Safari Lodge">
                </div>
                <div class="cbp-caption-activeWrap bg-primary" routerLink="/hotels/serengeti-safari-lodge">
                    <div class="cbp-l-caption-alignCenter">
                        <div class="cbp-l-caption-body">
                            <h4 class="h6 text-white mb-0">Serengeti Safari Lodge</h4>
                            <p class="small text-white-70 mb-0">
                                Click to learn more!
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <!-- End Item -->

        <!-- Item -->
        <div class="cbp-item rounded camp" id="serengetiWildebeestCampCube">
            <a class="cbp-caption">
                <div class="cbp-caption-defaultWrap">
                    <img width="320px" style="height:190px" appLazyload="hotels/wildebeest-camp/wildebeest-1-thumb.jpg" alt="Beautiful Bungalow at the Serengeti Wildebeest Camp">
                </div>
                <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-secondary' : 'bg-primary'"
                     routerLink="/hotels/serengeti-wildebeest-camp">
                    <div class="cbp-l-caption-alignCenter">
                        <div class="cbp-l-caption-body">
                            <h4 class="h6 text-white mb-0">Serengeti Wildebeest Camp</h4>
                            <p class="small text-white-70 mb-0">
                                Click to learn more!
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <!-- End Item -->

        <!-- Item -->
        <div class="cbp-item rounded lodge" id="ngorongoroSafariLodgeCube">
            <a class="cbp-caption">
                <div class="cbp-caption-defaultWrap">
                    <img width="320px" style="height:190px" appLazyload="hotels/ngorongoro-lodge/ngor-lodge-giraffe-thumb.jpg"
                         alt="A giraffe visits the Ngorongoro Safari Lodge">
                </div>
                <div class="cbp-caption-activeWrap bg-primary" routerLink="/hotels/ngorongoro-safari-lodge">
                    <div class="cbp-l-caption-alignCenter">
                        <div class="cbp-l-caption-body">
                            <h4 class="h6 text-white mb-0">Ngorongoro Safari Lodge</h4>
                            <p class="small text-white-70 mb-0">
                                Click to learn more!
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>


        <!-- End Item -->
        <div class="cbp-item rounded camp" id="serengetiWildCampCube">
            <a class="cbp-caption">
                <div class="cbp-caption-defaultWrap">
                    <img width="320px" style="height:190px" appLazyload="hotels/serengeti-camp/serengeti-wild-tents-thumb.jpg"
                         alt="Outside view of the rooms at the Serengeti Wild Camp">
                </div>
                <div class="cbp-caption-activeWrap" [ngClass]="showLegend ? 'bg-secondary' : 'bg-primary'"
                     routerLink="/hotels/serengeti-wild-camp">
                    <div class="cbp-l-caption-alignCenter">
                        <div class="cbp-l-caption-body">
                            <h4 class="h6 text-white mb-0">Serengeti Wild Camp</h4>
                            <p class="small text-white-70 mb-0">
                                Click to learn more!
                            </p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
    <!-- End Content -->
</div>
